<template lang="html">
<div class="pgInner affairEdit">

    <div class="headBar">新建文章</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
        <el-scrollbar ref="scroller" style="height:100%;">

            <div class="tabNavs" ref="tabNavs">
                <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
                    {{item}}
                </div>
                <div class="moveLine" :style="lineStr"></div>
            </div>

            <div class="tabContent">
                <Subpage1 @inited="readyHandle" :article="param.dto" ref="subpage1" v-show="navAct===0" />
                <Subpage2 @inited="readyHandle" :article="param.dto" ref="subpage2" v-show="navAct===1" />
            </div>

        </el-scrollbar>
    </div>

    <div class="pagefoot">

        <div v-if="pgState" class="loading">
            <span v-if="pgState == 1">初始化中...</span>
            <span v-if="pgState == 2">数据保存中...</span>
            <i class="el-icon-loading"></i>
        </div>
        <div v-else>
            <!-- <el-button @click="goSave(1)" type="primary" size="small">提交</el-button> -->
            <el-button @click="goSave()" type="primary" size="small">保存</el-button>
            <el-button @click="goReturn" size="small">返回</el-button>
        </div>

    </div>

</div>
</template>

<script>
import {
    updateProperty,
    check,
    getArticleDTOById
} from '@/api/jingshi';
import Subpage1 from "./src/Subpage1";
import Subpage2 from "./src/Subpage2";

export default {
    components: {
        Subpage1,
        Subpage2,
    },
    computed: {
        lineStr: function () {
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },
        pgState: function () {
            var state = 0;
            if (this.id && this.readyKey !== 3) {
                state = 1;
            }

            if (this.uploadIng) {
                state = 2;
            }

            return state;
        }
    },
    data() {
        return {
            id: '',
            navs: ['基本信息', '其他设置'],
            navAct: 0,
            navX: 15,
            pageH: '',
            readyKey: 0,
            uploadIng: false,
            param: {
                dto: {
                    id: '', //id
                    seoKeyword: '', //SEO关键字
                    columnId: '', // 栏目ID
                    editId: '', // 编辑者ID
                    title: '', //标题
                    seoTitle: '', // SEO标题
                    seoDesc: '', // SEO描述
                    content: '', // 内容
                    topProperty: '', // 置顶属性
                    views: '', // 浏览量
                    summary: '', //摘要
                    editor: '', //编辑者
                    thumbnail: '', // 缩略图
                    mages: '', //内容图
                    modelLink: '', //信息页模板链接
                    weight: '', //权重排序
                    hotProperty: '', //热门属性
                    reviewer: '', //审核者
                    meassage: '', //（审核）退回意见
                    checkTime: '', //审核时间
                    customLink: '', //自定义链接
                    recommendProperty: '', //推荐属性
                    columnName: '', //栏目名称
                    status: 1, // 1草稿、2待审核、3上线、4退回
                }
            }
        }
    },

    methods: {
        // 保存
        save() {
            var vues = this;
            var params = {
                id: vues.param.dto.id,
                status: vues.param.dto.status,
                meassage: vues.param.dto.meassage,
            }

            check(params).then(res => {
                console.log(res);
                this.$message.success('保存成功！');
                vues.goReturn();
            })
        },
        goSave() {
            var vues = this;
            var wait1 = this.$refs.subpage1.saveReturn();
            // var wait2 = this.$refs.subpage2.saveReturn();
            wait1.then(data => {
                console.log(data);
                if (data) {
                    for (let key in data) {
                        if (vues.param.dto.hasOwnProperty(key)) {
                            vues.param.dto[key] = data[key];
                        }
                    }
                    vues.save();
                }

            })
            // if (this.navAct == 0) {

            // }
            // if (this.navAct == 1) {
            //     wait2.then(data => {
            //         console.log(data);
            //         if (data) {
            //             for (let key in data) {
            //                 if (vues.param.dto.hasOwnProperty(key)) {
            //                     vues.param.dto[key] = data[key];
            //                 }
            //             }
            //             vues.save();
            //         }
            //     })
            // }

        },

        goReturn: function () {
            this.$router.go(-1);
        },

        tabChange: function (e, inx) {

            var tabNavs = this.$refs.tabNavs;
            this.navAct = inx;
            this.navX = e.target.offsetLeft;

        },
        pageFix: function () {
            this.pageH = document.documentElement.clientHeight - 205;
        },

        readyHandle: function () {
            this.readyKey++;
        },
        getDto: function () {
            var req = {
                id: this.param.dto.id,
            }
            getArticleDTOById(req).then(res => {
                this.param.dto = res.dto;
            });
        }
    },
    created: function () {
        var vues = this;
        var querys = this.$route.query;
        if (querys.id) {
            this.param.dto.id = querys.id;
            this.getDto();
        }
        // this.prevSet();
        $(window).resize(function () {
            vues.pageFix();
            if (vues.$refs.scroller.$data) {
                vues.$refs.scroller.$data.sizeHeight = this.pageH;
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.pgInner {
    background: #f5f5f5;
}

.headBar {
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    padding-left: 20px;
    background: white;
}

.tabNavs {
    height: 50px;
    padding-left: 15px;
    background: white;
    position: relative;

    .tabItem {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        margin-right: 45px;
        cursor: pointer;
    }

    .tabItem.act {
        color: rgb(86, 119, 252);
    }

    .moveLine {
        height: 2px;
        background: rgb(86, 119, 252);
        position: absolute;
        bottom: 0px;

        transition-property: all;
        transition-duration: 0.2s;
    }
}

.tabContent {
    padding: 20px;
    background: white;
}

.pagefoot {
    height: 60px;
    line-height: 60px;
    background: white;
    padding-left: 20px;
    position: relative;
    z-index: 2;

    .btn {
        height: 32px;
        padding: 0 12px;
        margin-right: 12px;
        display: inline-block;
        font-size: 14px;
        cursor: pointer;
    }

    .type1 {
        line-height: 32px;
        background: rgb(86, 119, 252);
        color: white;
    }

    .type2 {
        box-sizing: border-box;
        border: 1px solid #aeaeae;
        line-height: 30px;
    }

    .loading {
        font-size: 14px;
        padding-left: 24px;
        color: #aeaeae;

        i {
            font-size: 18px;
            vertical-align: middle;
        }
    }
}
</style>

<style lang="css">
.affairEdit .pgbody {
    margin: 20px;
    background: white;
}

@media only screen and (max-width: 1366px) {
    .affairEdit .pgbody {
        margin: 10px 0;
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?2da5776d